import React from "react";
import ContentListItem from "./ContentListItem";
import { Collapse, List } from "@material-ui/core";
import IContentsItem from "../../models/IContentsItem";

export interface IContentListProps extends IContentsItem {}

const ContentList = (props: IContentListProps) => {
  const { isOpen, leaf, items } = props;
  const [openOverride, setOpenOverride] = React.useState<boolean | undefined>();
  let open = isOpen;
  if (openOverride !== undefined) {
    open = openOverride;
  }

  const handleClick = (isExpander: boolean) => {
    if (!(isOpen || open) || isExpander) {
      setOpenOverride(!open);
    }
  };

  return (
    <>
      <ContentListItem onClick={handleClick} isOpen={open} {...props} />
      {!leaf && (
        <Collapse in={open} timeout="auto" unmountOnExit>
          <List dense>
            {items.map(item => (
              <ContentList key={item.href} {...item} />
            ))}
          </List>
        </Collapse>
      )}
    </>
  );
};

export default ContentList;
